
import i18n from '@/commons/translations/i18n'
import { ApplicationDocument } from '@/commons/types'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalBox from '@/commons/components/modal-box/ModalBox.vue'
import ModalBoxIsExpeditedContent from '@/commons/components/modal-box/ModalBoxIsExpeditedContent.vue'

@Component({
    components: {
        ModalBox
    }
})
export default class ModalBoxIsExpedited extends Vue {
    @Prop() deliveryTimeTranslationKey!: string
    @Prop() applicationDocument!: ApplicationDocument

    modalBoxBodyInstance (): Vue {
        return new ModalBoxIsExpeditedContent(
            {
                name: 'isExpeditedModal',
                i18n: i18n,
                propsData: {
                    applicationDocument: this.applicationDocument,
                    deliveryTimeTranslationKey: this.deliveryTimeTranslationKey
                }
            })
    }
}
